/*global Modernizr*/

import $ from 'qwery';

const GlobalHelpers = {

    placeholderDetection: function () {

        // check for placeholder support, using Modernizr detection
        if (!Modernizr.input.placeholder) {
            // if supported, check for classname and
            const labels = $('.js-showIfPlaceholderNotSupported'),
                labelCount = labels.length;

            for (let i = 0; i < labelCount; i++) {
                labels[i].classList.remove('is-visuallyHidden');
            }
        }
    },

    // pass in an array of scripts to load
    loadScripts: function (urls, cb) {

        const urlCount = urls.length;
        let urlsResponded = 0;

        function scriptLoaded (response) {
            console.log(response);
            urlsResponded++;

            if (urlCount === urlsResponded) {
                if (typeof cb === 'function') {
                    cb();
                }
            }
        }

        for (let i = 0; i < urlCount; i++) {
            console.log(`trying to load ${urls[i]}`);

            this.loadScript(urls[i])
                .then(scriptLoaded, scriptLoaded);
        }
    },

    // load a script from a url path
    loadScript: function (url) {

        var script = document.createElement('script');
        script.type = 'text/javascript';

        return new Promise((resolve, reject) => {
            if (script.readyState) { //IE
                script.onreadystatechange = function () {
                    if (script.readyState === 'loaded' || script.readyState === 'complete') {
                        script.onreadystatechange = null;
                        resolve(`Successfully loaded ${url}`);
                    }
                };
            } else { //Others
                script.onload = function () {
                    resolve(`Successfully loaded ${url}`);
                };
            }
            script.onerror = function () {
                reject(new Error(`Failed to load ${url}`));
            };

            script.src = url;
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    }
};

export default GlobalHelpers;
